<template>
  <base-modal>
    <tabs value="include" :animated="false" type="card">
      <tab-pane :label="$t('shared.component.recipient_form.tab.include.title')" name="include">
        <select-data-base :store="`${store}/include`" @close='$refs.close.$el.click()' />
      </tab-pane>
      <tab-pane :label="$t('shared.component.recipient_form.tab.exclude.title')" name="exclude">
        <select-data-base :store="`${store}/exclude`" @close='$refs.close.$el.click()' />
      </tab-pane>
      <tab-pane
        :label="$t('shared.component.recipient_form.tab.recipient.title')"
        name="recipients"
      >
        <div class="row">
          <div class="col-6">
            <numbers-input v-model="recipients" />
          </div>
          <div class="col-6 info-text">
            {{ $t('shared.component.recipient_form.tab.recipient.description') }}
          </div>
        </div>
      </tab-pane>
    </tabs>
    <template #footer-cancel="{ close }">
      <i-button size="large" @click="close()" ref="close">
        {{ $t('pbx.worksheet.modal.action.child.button.cancel') }}
      </i-button>
    </template>
    <i-button slot="footer-ok" size="large" type="success" @click="save">
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import SelectDataBase from './modal-recipient-input-databases';
  import NumbersInput from './modal-recipient-input-numbers';

  export default {
    components: {
      BaseModal,
      NumbersInput,
      SelectDataBase
    },

    props: {
      store: {
        type: String,
        default: ''
      },

      value: {
        type: Object,
        default: () => ({})
      }
    },

    computed: {
      recipients: {
        get: function() {
          return this.$store.getters[`${this.store}/numbers/value`];
        },
        set: function(val) {
          this.$store.commit(`${this.store}/numbers/value`, val);
        }
      },

      include: {
        get: function() {
          return this.$store.getters[`${this.store}/include/selected`];
        },

        set: function(val) {
          this.$store.commit(`${this.store}/include/selected`, val);
        }
      },

      exclude: {
        get: function() {
          return this.$store.getters[`${this.store}/exclude/selected`];
        },

        set: function(val) {
          this.$store.commit(`${this.store}/exclude/selected`, val);
        }
      }
    },

    watch: {
      'value.include': {
        handler: function(val) {
          this.include = val;
        },
        immediate: true,
        deep: true
      },

      'value.exclude': {
        handler: function(val) {
          this.exclude = val;
        },
        immediate: true,
        deep: true
      },

      'value.recipients': {
        handler: function(val) {
          this.recipients = val;
        },
        immediate: true,
        deep: true
      }
    },

    methods: {
      save: function() {
        this.$emit('success', {
          include: this.include,
          exclude: this.exclude,
          recipients: this.recipients
        });
      }
    }
  };
</script>
